import React, { useContext, useRef, useState, useEffect } from 'react'
import singlePodcast2 from '../assets/singlepodcast2.png'
import MusicCast from '../assets/MaterialSymbolsMusicCast.png'
import main2 from '../assets/Eventsmainimg2.png'
import { EventsContext } from '../context/EventsContext'
import { PiGooglePodcastsLogoBold } from "react-icons/pi";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { BiLeftArrowCircle } from "react-icons/bi";
import { BiRightArrowCircle } from "react-icons/bi";
import { getAppData } from '../apiService'
import { useNavigate } from 'react-router-dom'
import { ShimmerContentBlock, ShimmerText, ShimmerThumbnail } from 'react-shimmer-effects'
import { ApiContext } from '../context/ApiContext'


function Events() {
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    rows: 1,
    arrows: false,
  };
  const { allEvenst, setEventId, topEvents, setTopEvents } = useContext(EventsContext)
  const { AllEvents } = useContext(ApiContext)
  const navigate = useNavigate();
  const [localEvents, setLocalEvents] = useState([])
  const [trendingEvents, setTrendingEvents] = useState([])
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const slidersRef555 = useRef(null);

  useEffect(() => {
    setLoading(true)
    if (AllEvents) {
      setLoading(true)
      const local = AllEvents.filter((item) => item.isLocal == 1)
      setLocalEvents(local);
      const trend = AllEvents.filter((item) => item.isTrending == 1)
      setTrendingEvents(trend)
      const top = AllEvents.filter((item) => item.isTop == 1)
      setTopEvents(top)
      setLoading(false)
    }
  }, [AllEvents]);
  const morePodcasts = [
    { id: "ojfewi1", image: `${singlePodcast2}`, heading: "Premium story", author: "James Hoyce" },
    { id: "ojfewi2", image: `${singlePodcast2}`, heading: "Premium story", author: "James Hoyce" },
    { id: "ojfewi3", image: `${singlePodcast2}`, heading: "Premium story", author: "James Hoyce" },
    { id: "ojfewi4", image: `${singlePodcast2}`, heading: "Premium story", author: "James Hoyce" },
  ]

  const recentPlayed = [
    { id: "fgewqy1", image: `${MusicCast}`, heading: "Premium story", author: "James Hoyce" },
    { id: "fgewqy2", image: `${MusicCast}`, heading: "Premium story", author: "James Hoyce" },
    { id: "fgewqy3", image: `${MusicCast}`, heading: "Premium story", author: "James Hoyce" },
  ]
  const recentPlayedforPhone = [
    { id: "fgewqy1", image: `${MusicCast}`, heading: "Premium story", author: "James Hoyce" },
    { id: "fgewqy2", image: `${main2}`, heading: "Premium story", author: "James Hoyce" },
    { id: "fgewqy31", image: `${MusicCast}`, heading: "Premium story", author: "James Hoyce" },
    { id: "fgewqy32", image: `${main2}`, heading: "Premium story", author: "James Hoyce" },
  ]


  if (loading || (!trendingEvents.length && !localEvents.length && !topEvents.length)) {
    return (
      <div className='layout6-div'>
        {/* <div className='shimmer-News-for-laptop'> */}
        <div className='Main-div-with-three-main-content-divs-in-events'>
          <div className='Main-inner-more-podcasts-in-events'>
            <p class="main-inner-more-podcast-main-heading">Trending Events</p>
            <hr className='main-inner-more-podcast-hr' />
            <div className='main-inner-recently-played-all-recently-played-here1'>
              <ShimmerContentBlock
                title
                text
                cta
                thumbnailWidth={170}
                thumbnailHeight={170}
                style={{ marginBottom: "10px" }}
              /></div>
            <div className='main-inner-recently-played-all-recently-played-here1'>
              <ShimmerContentBlock
                title
                text
                cta
                thumbnailWidth={170}
                thumbnailHeight={170}
                style={{ marginBottom: "10px" }}
              /></div>
            <div className='main-inner-recently-played-all-recently-played-here1'>
              <ShimmerContentBlock
                title
                text
                cta
                thumbnailWidth={170}
                thumbnailHeight={170}
                style={{ marginBottom: "10px" }}
              />
            </div>
          </div>
          <div className='Main-inner-all-events-image-will-displayed-here'>
            <p class="main-inner-for-mobile-all-events-image-text">Local Play</p>
            <div className='slider-container555'>
              {/* <ShimmerSimpleGallery card imageHeight={800} caption /> */}
              <ShimmerThumbnail height={450} rounded />
              {/* <div>
                         <ShimmerText line={3} gap={10} />
                         </div> */}
            </div>
          </div>
          <div className='Main-inner-recently-played-podcasts-in-events'>
            <p class="main-inner-recently-played-main-heading">Top Events</p>
            <hr className='main-inner-recently-played-hr' />
            <div className='main-inner-recently-played-all-recently-played-here1'>
              <ShimmerContentBlock

                title
                text={{ lines: 100 }}
                cta
                thumbnailWidth={170}
                thumbnailHeight={70}
                style={{ marginBottom: "10px" }}
              />
            </div>
            <div className='main-inner-recently-played-all-recently-played-here1'>
              <ShimmerContentBlock
                title
                text
                cta
                thumbnailWidth={170}
                thumbnailHeight={170}
                style={{ marginBottom: "10px" }}
              />
            </div>
            <div className='main-inner-recently-played-all-recently-played-here1'>
              <ShimmerContentBlock
                title
                text
                cta
                thumbnailWidth={170}
                thumbnailHeight={170}
                style={{ marginBottom: "10px" }}
              />
            </div>

          </div>
        </div>

        {/* </div> */}
        <div className='shimmer-News-for-mobile'>
          <div className='news-internal-main-div'>
            {/* <div className='Main-div-with-three-main-content-divs-in-events'>
     <ShimmerThumbnail height={250} rounded />
                         <div>
                         <ShimmerText line={3} gap={10} />
                         </div>
     </div> */}
            <div className='Main-inner-more-podcasts-in-events555'>
              <p className='main-inner-more-podcast-main-heading555'>Trending Events</p>
              <hr className='main-inner-more-podcast-hr555' />
              <div className='main-inner-more-podcasts-all-more-podcast-here555'>
                <div className='main-inner-recently-played-all-recently-played-here1'>
                  <ShimmerContentBlock
                    title
                    text
                    cta
                    thumbnailWidth={170}
                    thumbnailHeight={170}
                    style={{ marginBottom: "10px" }}
                  /></div>
                <div className='main-inner-recently-played-all-recently-played-here1'>
                  <ShimmerContentBlock
                    title
                    text
                    cta
                    thumbnailWidth={170}
                    thumbnailHeight={170}
                    style={{ marginBottom: "10px" }}
                  /></div>
                <div className='main-inner-recently-played-all-recently-played-here1'>
                  <ShimmerContentBlock
                    title
                    text
                    cta
                    thumbnailWidth={170}
                    thumbnailHeight={170}
                    style={{ marginBottom: "10px" }}
                  /></div>
              </div>

            </div>
          </div>

        </div>
      </div>
    );
  }

  if (error) {
    return (
      <>
        <div className="blur-background"></div>
        <div className="error-container">
          <p>{error}</p>
        </div>
      </>
    )
  }
  const handleClick = (id) => {
    setEventId(id);
    navigate(`/myevents`)
  }

  return (
    <div className='layout6-div'>
      <div className='Main-div-with-three-main-content-divs-in-events'>
        <div className='Main-inner-more-podcasts-in-events'>
          <p className='main-inner-more-podcast-main-heading'>Trending Events</p>
          <hr className='main-inner-more-podcast-hr' />
          {trendingEvents.map((item) => (
            <div className='main-inner-more-podcasts-all-more-podcast-here' key={item.id} onClick={() => handleClick(item.id)}>
              <div className='main-inner-more-podcast-inside-content-for-more-podcasts'>
                <div className='main-inner-more-podcast-inside-image-for-more-podcasts-main-div'>
                  <img className='main-inner-more-podcast-inside-image-for-more-podcasts' src={item.image} alt="singlePodcast" style={{ width: "100px", height: "100px", objectFit: "cover", borderRadius: "8px", marginRight: "10px" }} />
                </div>
                <div className='main-inner-more-podcast-inside-paras-for-more-podcasts'>
                  <p className='main-inner-more-podcast-para1'>{item.title}</p>
                  {/* <p className='main-inner-more-podcast-para2'>{item.author}</p> */}
                </div>
              </div>
              <hr className='main-inner-recently-played-hr-all' />
            </div>
          ))}
        </div>
        <div className='Main-inner-all-events-image-will-displayed-here'>
          <p className='main-inner-for-mobile-all-events-image-text'>Local Play</p>
          <div className="slider-container555">
            <button className="slider-arrow555 left555" onClick={() => slidersRef555.current.slickPrev()}>
              <BiLeftArrowCircle />
            </button>

            <div className="slider-wrapper555">
              <Slider ref={slidersRef555} {...settings}>
                {localEvents.map((item) => (
                  <div key={item.id} className="slide-item" onClick={() => handleClick(item.id)}>
                    <div className="slider-d-jhu555" style={{ cursor: "pointer" }}>
                      <div className='podcast-hjgwqjht5551'><img className='css-nadvt4' src={item.image} alt={`Slide ${item.image}`} /></div>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>

            <button className="slider-arrow555 right555" onClick={() => slidersRef555.current.slickNext()}>
              <BiRightArrowCircle />
            </button>
          </div>
          {/* {allEvenst.map((item)=>(
            <>
            <div className='main-inner-all-events-main-div-of-all-images' key={item.id}>
            <img src={item.image} alt="eventmainimage" className='main-inner-all-events-main-div-of-single-image' />
          </div>
            <p className='main-inner-all-events-main-div-of-all-heading'>{item.heading}</p>
            <div className='main-inner-all-events-main-div-of-all-date-and-time'><p>{item.time}</p> <p>{item.date}</p></div>
            </>
          ))} */}
        </div>
        {/* <div className='main-inner-all-events-main-div-of-all-social-events-outer-div'>
              <div className='main-inner-all-events-main-div-of-all-social-events-inner-div'>
                <div className='main-inner-all-events-main-div-of-all-social-events-inner-div-icon-and-text'>
                <PiGooglePodcastsLogoBold style={{fontWeight:"23px",marginRight:"8px"}} />
                  <p>Social Events</p>
                </div>
                <p className='main-inner-all-events-main-div-of-all-social-events-inner-div-text'>explore</p>
              </div>
            </div> */}

        {/* <div className='main-inner-only-for-phone-screen-recently-played'>
              <p className='main-inner-only-for-phone-screen-recently-played-text'>Topss Events</p>
              <div className='main-inner-only-for-phone-screen-recently-played-main-content'>
              {recentPlayedforPhone.map((item)=>(
           <div className='main-inner-recently-played-all-recently-played-here' key={item.id}>
           <div className='main-inner-recently-played-inside-content-for-recently-played'>
             <img className='main-inner-more-recently-played-image-for-recently-played' src={item.image} alt="singlePodcast" />
             <div className='main-inner-more-recently-played-paras-for-recently-played'>
               <p className='main-inner-recently-played-para1'>{item.heading}</p>
               <p className='main-inner-recently-played-para2'>{item.author}</p>
             </div>
           </div>
         </div>
         ))}
         </div>
              <div>

              </div>
            </div> */}
        <div className='Main-inner-recently-played-podcasts-in-events'>
          <p className='main-inner-recently-played-main-heading'>Top Events</p>
          <hr className='main-inner-recently-played-hr' />
          {topEvents.map((item) => (
            <div className='main-inner-recently-played-all-recently-played-here' key={item.id} onClick={() => handleClick(item.id)}>
              <div className='main-inner-recently-played-inside-content-for-recently-played'>
                <div className='main-inner-more-podcast-inside-image-for-more-podcasts-main-div1'>
                  <img className='main-inner-more-recently-played-image-for-recently-played' src={item.image} alt="singlePodcast" style={{ width: "100px", height: "100px", objectFit: "cover", borderRadius: "8px", marginRight: "10px" }} />
                </div>
                <div className='main-inner-more-recently-played-paras-for-recently-played'>
                  <p className='main-inner-recently-played-para1'>{item.title}</p>
                  <p className='main-inner-recently-played-para2'>{item.author}</p>
                </div>
              </div>
              <hr className='main-inner-recently-played-hr-all' />
            </div>
          ))}
        </div>

        <div className='Main-inner-more-podcasts-in-events555'>
          <p className='main-inner-more-podcast-main-heading555'>Trending Events</p>
          <hr className='main-inner-more-podcast-hr555' />
          {trendingEvents.map((item) => (
            <div className='main-inner-more-podcasts-all-more-podcast-here555' key={item.id} onClick={() => handleClick(item.id)}>
              <div className='main-inner-more-podcast-inside-content-for-more-podcasts555'>
                <div className='main-inner-more-podcast-inside-image-for-more-podcasts-main-div555'>
                  <img className='main-inner-more-podcast-inside-image-for-more-podcasts555' src={item.image} alt="singlePodcast" style={{ width: "100px", height: "100px", objectFit: "cover", borderRadius: "8px", marginRight: "10px" }} />
                </div>
                <div className='main-inner-more-podcast-inside-paras-for-more-podcasts555'>
                  <p className='main-inner-more-podcast-para1555'>{item.title}</p>
                  {/* <p className='main-inner-more-podcast-para2'>{item.author}</p> */}
                </div>
              </div>
              {/* <hr className='main-inner-recently-played-hr-all555'/>  */}
            </div>
          ))}
        </div>

      </div>

    </div>
  )
}

export default Events